import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { forEach, noop, entries } from 'lodash';
import { UI_EVENTS, VIDEO_EVENTS, EngineState } from 'playable/dist/src/constants';
export class PlayerAPIFacade extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "unbindEvents", () => {
      const {
        eventEmitter
      } = this.props;
      forEach(this.listeners, (handler, event) => {
        eventEmitter.off(event, handler);
        delete this.listeners[event];
      });
    });
    _defineProperty(this, "addListener", (event, handler) => {
      const {
        eventEmitter
      } = this.props;
      const wrappedHandler = function () {
        if (_this._isMounted) {
          handler(...arguments);
        }
      };
      this.listeners[event] = wrappedHandler;
      eventEmitter.on(event, wrappedHandler);
    });
    _defineProperty(this, "setPlaybackStatusState", _ref => {
      let {
        nextState
      } = _ref;
      this.setState({
        isVideoEnded: nextState === EngineState.ENDED,
        isVideoPaused: nextState === EngineState.PAUSED,
        isVideoPlaying: nextState === EngineState.PLAYING
      });
      this.props.onPlaybackStateChanged(nextState);
    });
    _defineProperty(this, "showMainBlockControls", () => {
      this.setState({
        isControlsShown: true
      });
    });
    _defineProperty(this, "hideMainBlockControls", () => {
      this.setState({
        isControlsShown: false
      });
    });
    _defineProperty(this, "setFullScreenState", isPlayerInFullScreen => {
      this.setState({
        isPlayerInFullScreen
      });
      this.props.onFullScreenChanged(Boolean(isPlayerInFullScreen));
    });
    _defineProperty(this, "hidePlayerUI", () => {
      const {
        mainUIBlock,
        cards
      } = this.props;
      mainUIBlock.disableShowingContent();
      mainUIBlock.hide();
      cards.hide();
    });
    _defineProperty(this, "showPlayerUI", () => {
      const {
        mainUIBlock,
        cards
      } = this.props;
      mainUIBlock.enableShowingContent();
      mainUIBlock.show();
      cards.show();
    });
    _defineProperty(this, "exitFullScreen", () => {
      const {
        fullScreenManager
      } = this.props;
      if (fullScreenManager.isInFullScreen) {
        fullScreenManager.exitFullScreen();
      }
    });
    _defineProperty(this, "pauseVideo", () => {
      const {
        engine
      } = this.props;
      engine.pause();
    });
    this._isMounted = false;
    this.listeners = {};
    this.state = {
      isVideoEnded: false,
      isVideoPaused: true,
      isControlsShown: false,
      isPlayerInFullScreen: false
    };
    this.bindEvents();
  }
  componentDidMount() {
    this._isMounted = true;
  }
  componentWillUnmount() {
    this.unbindEvents();
    this._isMounted = false;
  }
  bindEvents() {
    const {
      onError,
      onPlayAbort,
      onSeek,
      onUserSeek,
      onMute,
      onVolumeChange
    } = this.props;
    const uiHandlers = {
      [UI_EVENTS.MAIN_BLOCK_SHOW]: this.showMainBlockControls,
      [UI_EVENTS.MAIN_BLOCK_HIDE]: this.hideMainBlockControls,
      [UI_EVENTS.FULL_SCREEN_STATE_CHANGED]: this.setFullScreenState,
      [UI_EVENTS.PROGRESS_CHANGE]: onUserSeek,
      [UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD]: onUserSeek,
      [UI_EVENTS.GO_FORWARD_WITH_KEYBOARD]: onUserSeek
    };
    const videoHandlers = {
      [VIDEO_EVENTS.STATE_CHANGED]: this.setPlaybackStatusState,
      [VIDEO_EVENTS.ERROR]: onError,
      [VIDEO_EVENTS.PLAY_ABORTED]: onPlayAbort,
      [VIDEO_EVENTS.SEEK_IN_PROGRESS]: onSeek,
      [VIDEO_EVENTS.MUTE_CHANGED]: onMute,
      [VIDEO_EVENTS.VOLUME_CHANGED]: onVolumeChange
    };
    entries({
      ...uiHandlers,
      ...videoHandlers
    }).forEach(_ref2 => {
      let [eventName, handler] = _ref2;
      this.addListener(eventName, handler);
    });
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React.createElement("section", null, React.Children.map(children, child => child ? /*#__PURE__*/React.cloneElement(child, {
      ...this.state,
      pauseVideo: this.pauseVideo,
      exitFullScreen: this.exitFullScreen,
      hidePlayerUI: this.hidePlayerUI,
      showPlayerUI: this.showPlayerUI
    }) : child));
  }
}
_defineProperty(PlayerAPIFacade, "dependencies", ['engine', 'eventEmitter', 'fullScreenManager', 'mainUIBlock', 'cards']);
_defineProperty(PlayerAPIFacade, "defaultProps", {
  onSeek: noop,
  onUserSeek: noop,
  onError: noop,
  onPlayAbort: noop,
  onMute: noop,
  onVolumeChange: noop,
  onPlaybackStateChanged: noop
});
//# sourceMappingURL=player-api-facade.js.map